import { Link } from 'react-router-dom';
import { FolderOpenOutlined } from '@ant-design/icons';
import { Highlight } from '@/shared/ui/Highlight';
import { useStudyPrefetch } from '@/state/hooks/useStudyPrefetch';
import { formatStudyDate } from '@/shared/utils/studyDate';
import { formatName } from '@/utils/search';
import type { SearchStudy } from '@/models/search';
import styles from '../../GlobalSearch.module.css';

const DROPDOWN_LIMIT = 5;

export const StudyResults = ({
  studies,
  onSelect,
  query,
  highlightIndex = -1,
  highlightOffset = 0,
}: {
  studies: SearchStudy[];
  onSelect: (path: string) => void;
  query: string;
  highlightIndex?: number;
  highlightOffset?: number;
}) => {
  const prefetchStudy = useStudyPrefetch();
  if (studies.length === 0) return null;
  const visible = studies.slice(0, DROPDOWN_LIMIT);

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <FolderOpenOutlined className={styles.sectionIcon} />
        Studies
      </div>
      {visible.map((study, idx) => {
        const studyDate = formatStudyDate(study.studyDate);
        const isActive = highlightIndex === highlightOffset + idx;
        return (
          <Link
            key={study.uuid}
            to={`/studies/${study.uuid}`}
            className={`${styles.resultItem} ${isActive ? styles.resultItemActive : ''}`}
            onClick={() => onSelect(`/studies/${study.uuid}`)}
            onMouseEnter={() => prefetchStudy(study.uuid)}
          >
            <div className={`${styles.resultIcon} ${styles.study}`}>
              <FolderOpenOutlined />
            </div>
            <div className={styles.resultContent}>
              <span className={styles.resultPrimary}>
                <Highlight
                  text={formatName(
                    study.patientFirstName,
                    study.patientLastName
                  )}
                  query={query}
                />
                {study.modality && (
                  <span className={`${styles.tag} ${styles.tagStudy}`}>
                    {study.modality}
                  </span>
                )}
                {studyDate && (
                  <span className={styles.resultMeta}> · {studyDate}</span>
                )}
              </span>
              {study.accessionNumber && (
                <span className={styles.resultSecondary}>
                  ACC: <Highlight text={study.accessionNumber} query={query} />
                </span>
              )}
            </div>
          </Link>
        );
      })}
    </div>
  );
};
